import { AppShell } from '@/components/shell'
import { ManagerDashboard } from '@/components/ManagerDashboard'

const Index = () => {
  return (
    <AppShell>
      <ManagerDashboard />
    </AppShell>
  )
}

export default Index
